export const MOTIFS_RETRAIT = [
  ['ARTICLE_MANQUANT', 'Article manquant'],
  ['ARTICLE_ABIME', 'Article abîmé'],
  ['PROBLEME_QUALITE', 'Problème qualité'],
  ['MARQUAGE_ERRONE', 'Marquage erroné'],
  ['MAUVAIS_ARTICLE', 'Mauvais article'],
  ['MAUVAISE_TAILLE', 'Mauvaise taille'],
  ['AUTRE', 'Autre'],
];

export function initialiserControle(lignes = []) {
  return lignes.map((ligne) => ({
    ligne_id: ligne.ligne_id,
    quantite_presentee: Number(ligne.quantite || 0),
    quantite_remise: Number(ligne.quantite || 0),
    motif: '',
    observation: '',
  }));
}

export function appliquerDecision(lignes, decision) {
  return lignes.map((ligne) => {
    if (decision === 'NE_RIEN_PRENDRE') return { ...ligne, quantite_remise: 0 };
    if (decision === 'PRENDRE_CONFORMES' && ligne.motif) return { ...ligne, quantite_remise: 0 };
    return ligne;
  });
}

export function resultatRetrait(lignes = []) {
  const presente = lignes.reduce((s, l) => s + Number(l.quantite_presentee || 0), 0);
  const remise = lignes.reduce((s, l) => s + Number(l.quantite_remise || 0), 0);
  const anomalies = lignes.filter((l) => l.motif).length;
  if (presente > 0 && remise === presente && anomalies === 0) return 'RETRAIT_TOTAL';
  if (remise === 0) return 'REFUS_TOTAL';
  return 'RETRAIT_PARTIEL';
}

export function validerRetrait({ lignes = [], decision, methode, code, signature }) {
  if (!lignes.length) return 'Aucun article à contrôler.';
  if (lignes.some((l) => l.motif === 'AUTRE' && !String(l.observation || '').trim())) return 'Une observation est obligatoire pour le motif Autre.';
  if (lignes.some((l) => Number(l.quantite_remise) > Number(l.quantite_presentee) || Number(l.quantite_remise) < 0)) return 'Quantité remise invalide.';
  if (decision === 'NE_RIEN_PRENDRE' && lignes.some((l) => Number(l.quantite_remise) > 0)) return 'Aucun article ne peut être remis après un refus total.';
  if (lignes.some((l) => l.motif === 'ARTICLE_MANQUANT' && Number(l.quantite_remise) > 0)) return 'Un article manquant ne peut pas être remis.';
  if (!['PIECE_ET_CODE', 'PIECE_SANS_CODE', 'CLIENT_CONNU_MAGASIN'].includes(methode)) return "Sélectionnez une méthode de contrôle d'identité.";
  if (methode === 'PIECE_ET_CODE' && !/^\d{6}$/.test(String(code || ''))) return 'Le code de confirmation doit contenir 6 chiffres.';
  if (!String(signature || '').startsWith('data:image/')) return 'La signature du client est obligatoire.';
  return '';
}

export function commandeSepareeParClub(commandes = []) {
  return commandes.every((commande, index) => commandes.findIndex((x) => x.commande_id === commande.commande_id) === index)
    && new Set(commandes.map((x) => x.commande_id)).size === commandes.length;
}
